const display = {
  'hiv-risk': {
    css: {
      'some-class': 'actual-classname-that-we-want'
    }
  },
  pearls: {
    css: {
      //'assessment-step': 'assessment-step row',
      //'assessment-step-question': 'assessment-step-question col-md-4',
      //'assessment-step-body': 'assessment-step-body col-md-8',
      'assessment-screen-question': 'assessment-screen-question col-md-4',
      'assessment-screen-body': 'assessment-screen-body col-md-8',
      'results-map': 'results-map row',
      'results-map-detail': 'results-map-detail col-md-4',
      'results-map-body': 'results-map-body col-md-8',
      'assessment-review-actions': 'actions',
      'assessment-complete-actions': 'actions'
    }
  }
};

export default display;
